export const postColumnsConfig = {
TITLE: "Title",
DESCRIPTION: "Description",
MEDIATYPE: "Media Type",
MEDIA: "Media",
AUTHOR: "User Name",
CREATED: "Created At",
ACTIONS: "Actions",
message: "Are you sure you want to delete this post?",
};